export default __webpack_public_path__ + "static/media/pyramid.069ec080.png";